<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.deptName"
        placeholder="学院名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn
  },
  data() {
    return {
      filters: {},
      deptUnitAttr: [],
      deptAttrCategory: []
    };
  },
  created() {
    this.getSysParamByTypes(["DEPT_UNIT_ATTR", "DEPT_ATTR_CATEGORY"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["DEPT_UNIT_ATTR"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["DEPT_ATTR_CATEGORY"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.deptUnitAttr = res.data["DEPT_UNIT_ATTR"];
        this.deptAttrCategory = res.data["DEPT_ATTR_CATEGORY"];
      });
    },
    initData() {
      //查询
      this.$emit("search", this.filters);
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", {});
    }
  }
};
</script>
